import type { NavigationButton, DividerMenuItem, LinkMenuItem } from '@core/ui/navigation';
import { createHomeTypeQuery } from './utils';

const createDivider = (): DividerMenuItem => ({
  id: `divider-${Math.random().toString(36).substr(2, 9)}`,
  type: 'divider',
});

const createLinkItem = (id: string, label: string, href: string, external?: boolean): LinkMenuItem => ({
  id,
  type: 'link',
  label,
  href,
  external,
});

const createTemplatedLinkItem = (id: string, template: string, href: string): LinkMenuItem => ({
  id,
  type: 'link',
  template,
  href,
});

export const headerNavigationItems: NavigationButton[] = [
  {
    id: 'buy',
    buttonVariant: 'dropdown',
    label: 'Buy',
    items: [
      createTemplatedLinkItem('city-real-estate', '{city} Real Estate', '/{city-slug}-real-estate'),
      createLinkItem('houses-sale', 'Houses for Sale', '/{city-slug}-real-estate/houses'),
      createLinkItem('condos-sale', 'Condos for Sale', '/{city-slug}-real-estate/condos'),
      createLinkItem('townhouses-sale', 'Townhouses for Sale', '/{city-slug}-real-estate/townhouses'),
      createLinkItem('open-houses', 'Open Houses', '/{city-slug}-real-estate/open-houses'),
      createLinkItem('recently-sold', 'Recently Sold', '/{city-slug}-real-estate/sold'),
      createDivider(),
      createLinkItem('new-listings', 'New Listings', '/{site-location}-real-estate?sort=-date'),
      createLinkItem('new-construction', 'New Construction', '/newhomes'),
      createLinkItem('buying-info', 'Information about Buying', 'https://www.zoocasa.com/blog/category/buying-a-home/', true),
    ],
  },
  {
    id: 'rent',
    buttonVariant: 'dropdown',
    label: 'Rent',
    items: [
      createTemplatedLinkItem('city-rentals', '{city} Rentals', '/{city-slug}-real-estate/for-rent'),
      createLinkItem('houses-rent', 'Houses for Rent', `/{city-slug}-real-estate/filter?rental=true&${createHomeTypeQuery(['house'])}`),
      createLinkItem('condos-rent', 'Condos for Rent', `/{city-slug}-real-estate/filter?rental=true&${createHomeTypeQuery(['condo'])}`),
      createLinkItem('townhouses-rent', 'Townhouses for Rent', `/{city-slug}-real-estate/filter?rental=true&${createHomeTypeQuery(['townhouse'])}`),
      createDivider(),
      createLinkItem('new-rental-listings', 'New Listings', '/{site-location}-real-estate/for-rent?sort=-date'),
      createLinkItem('renting-info', 'Information about Renting', 'https://www.zoocasa.com/blog/?s=rent', true),
    ],
  },
  {
    id: 'sell',
    buttonVariant: 'dropdown',
    label: 'Sell',
    items: [
      createTemplatedLinkItem('city-recently-sold', '{city} Recently Sold', '/{city-slug}-real-estate/sold'),
      createLinkItem('sell-with-zoocasa', 'Sell with Zoocasa', 'https://zoocasa.ac-page.com/home-sellers-guide', true),
      createLinkItem('home-appraisal', 'Home Appraisal', '/home-appraisal'),
      createDivider(),
      createLinkItem('selling-info', 'Information about Selling', 'https://www.zoocasa.com/blog/category/selling-your-home/', true),
    ],
  },
]; 